var _style, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandHell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-hell",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1060 420",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        #hand-hell-u-fire_to {animation: hand-hell-u-fire_to__to 3000ms linear 1 normal forwards}@keyframes\n        hand-hell-u-fire_to__to { 0% {transform: translate(210px,820.366px)} 6.666667% {transform:\n        translate(210px,820.366px);animation-timing-function: cubic-bezier(0,0,0.58,1)} 16.666667% {transform:\n        translate(210px,480.366px)} 100% {transform: translate(210px,480.366px)}} #hand-hell-u-hand_to {animation:\n        hand-hell-u-hand_to__to 3000ms linear 1 normal forwards}@keyframes hand-hell-u-hand_to__to { 0% {transform:\n        translate(727.92px,1198.266px)} 13.333333% {transform: translate(727.92px,750.266px)} 100% {transform:\n        translate(727.92px,750.266px)}} #hand-hell-u-hand_tr {animation: hand-hell-u-hand_tr__tr 3000ms linear 1 normal\n        forwards}@keyframes hand-hell-u-hand_tr__tr { 0% {transform: rotate(7deg)} 13.333333% {transform: rotate(0deg)}\n        100% {transform: rotate(0deg)}}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-groupe_358",
    transform: "translate(-210-422.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-fire_to",
    transform: "translate(210,820.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-fire",
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-groupe_357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1412",
    d: "M438.7,100.3c1.3-2.1,2.4-4.3,3.4-6.5-1.4,2.1-2.5,4.3-3.4,6.5v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-s-path1",
    d: "M1057.8,284.9c-2.9-9.6-29.2-39.6-23.7-45.7-12.7,13.4-29.5,5.8-44.9,8.8-16.3,3.2-22.5,24.2-37.7,28.5c4-9,4.3-19.3.9-28.5-4.2-10.5-11.9-14.3-11.5-26.5-7.5,6.6-15,13.1-22.4,20c2.8-24.7.3-47.5-13.2-69.2-10-16.2-25.2-28.9-17.6-48.9-14.7,10.4-32.2,15.1-48,24.4-17.1,10-23.6,37.5-43.8,40.8c1.2-3.9.6-8.2,2-11.7-22.9,23-31.5,51.4-65.5,62.8-13,4.4-23.9,7.4-34.2,14.9-5.4-10.8-12.6-20.5-21.4-28.8-7.8-7.3-29-17.4-17.5-30-9.1,3.6-13.9,13.3-20.8,19.7-9.1,8.4-17.6,7.8-26.9,15.2-4.7,3.8-7.9,5.9-10.1,6.2-3.8.6-4.9-3.8-6.4-13.4-.7-4.5-.5-11-1.8-15.4-1.1-3.9-5.4-9.4-6.1-11.4-1.4,3.9-3.2,7.2-5.3,10.1-4.1,5.5-9.5,9.5-15.4,12.5-8.6,4.5-18.4,7.1-27.4,10.2-19.5,6.7-24,32.1-42.8,36.7-1.6-9.8,6.8-14.4,8.8-22.6c1-4.1.9-10.1.5-15.9-.3-3.9-.8-7.6-1.2-10.5-.7-5-3.5-12.4-5.7-20-2-6.6-3.5-13.5-2.9-19.2.4-3.6,1.6-6.7,4-9-11.9,9.9-16.3,26.8-28.3,36.2-11,8.7-22.9,11-31.8,22.9c3.1-10.6,11.6-20.8,14.4-31.3c2.4-8.9-.6-24.5-2.9-34-.1-.6-.3-1.2-.4-1.8-.7-2.7-1.5-5.4-2.5-8.1v0c-.6-1.8-1.3-3.5-2-5.3-2.1-5.5-4.5-11.1-6.4-16.6-1.3-3.8-2.4-7.7-3-11.5v-.1c-1-6.3-.8-12.7,1.7-19-1.5,2.4-3.1,4.6-4.9,6.6-4.7,5.3-10.3,9.4-16.2,13.3-5.6,3.7-11.6,7.1-17.5,11.3-10.1,7.2-16.8,12.8-21.2,24.4-3.2,8.3-4.8,15.7-12.4,21.4-.4-7.2-8.7-15.3-5.2-22.1-10.6,17.7-22.3,29.8-41.8,38.6-17.7,7.9-41.5,15.4-50.6,33.8-8.7,17.5-7.4,56.8-36.4,53c.8-6,1-12.1.7-18.2-11.5,13.1-37.3,14.9-41.8,33.4.7-16.6,4.9-27.6-3.8-43.9-7.1-13.3-13.9-21.2-14.6-36.3-5.1,26.5-40.8,29.2-61.2,37.3-12.3,4.9-19.7,12.3-26.6,23.8-5.1,8.5-4.6,19.7-15.5,22.4c1.9-9.8-.8-17.2-4.1-26.4c5.1,15.8-36.3,35.4-47.5,43.9C2.4,328.5,0.1,345.3,0,361.8h1025.3c38.6-15.4,36.8-62.9,32.5-76.9ZM584.5,362.6v0v0v0v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1414",
    d: "M471.6,137.5l-.4-.4c0,.4.2.5.4.4v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1415",
    d: "M497.2,62.1c-1.2,27-47.3,38.4-29.7,71.3l3.7,3.7c0-1.1,1.1-4,2.7-6.5c1.9-2.8,4.2-5.3,6.6-7.6c4.3-4.3,10.3-7.6,13.8-12.8c9.4-13.9,2.9-32.5,2.9-48.1v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1416",
    d: "M537.1,155.9c.3-7,3.3-17.2,2.3-22.4-2.7,23.5-40.9,35-28.9,61.3l1,24.6c1.4-15.1,17.9-23.4,23.8-37.8c3.3-7.9,1.5-17.2,1.8-25.7v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1417",
    d: "M376.5,77c-2.2,5.6-8.2,14.2-12.6,20.6-4.4,6.5-6.8,18.3-12.8,22.5.3-2.8-.7-6.2-.4-9-3.1,4.1-3.3,9.2-7.7,13.4-4.3,4.1-11.6,6.4-16.6,9.8-9.3,6.3-21.7,17.7-15.5,30c8-13.9,36.4-20.9,47.1-27.9c21.8-14.6,19.1-36.5,18.5-59.4v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1418",
    d: "M946.4,64.2c-6.6,13.6-8.9,22.6-21.6,33.7-8.7,7.6-28.7,25.5-21.6,39.4c2.5,4.9,7.8,20.6,7.8,20.6c3-18.4,17.6-28.5,29.2-42.6c11.5-14,5.9-34,6.2-51.1v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1419",
    d: "M887.6,62.5c.7-2.4,1.1-4.8,1.3-7.3-.9,2.4-1.4,4.9-1.3,7.3v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1420",
    d: "M887.5,62.5c-3.2,11.2-11.9,19.6-21,27.1-8.6,7.1-17.9,15.7-17.6,27.4l-2.3,19.9c-.1.9,0,1.9,0,2.8c7.5-16.1,19.1-24.7,30.9-37.9c5.6-6.3,9.2-14.1,10.4-22.5.7-4.9-.5-11.1-.4-16.8v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1421",
    d: "M911,55.2c-1.3,6.8,3.8,25,3.8,25c4.7-7.7,9.1-12,11.5-20.7c1.9-6.9,4-13.7,7.5-20.1c3.6-6.6,5.8-11.4,6.9-19c.7-4.3.9-9.4,1.8-14C934.7,21.7,915.6,32,911,55.2v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1422",
    d: "M942.6,6.5c1.1-2,1.8-4.2,2.2-6.5-1,2-1.7,4.2-2.2,6.5v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1423",
    d: "M202.1,173.4c-2,13.7-11.5,19.9-18.6,30.4-5.8,8.5-8.7,21.9,1,27.7l10,19.9c1.4,1.4,3.8-13.9,3.8-17.8c0-7.5-4.1-13.4-4.6-20.5-1-13.3,8.4-25.7,8.4-39.7v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1424",
    d: "M626.4,154.9c-3.2,12.1-15.1,15.7-22.8,24.5-9.1,10.4-1.3,19.9-2.5,31.3v14.6c-.1.9-.1,1.9,0,2.8c2.3-14.4,17-20.2,22.5-32.6c3-6.8.2-13.9-.2-20.9-.5-6.9,1.5-13.1,3-19.7v0Z",
    fill: "#f37e72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1425",
    d: "M459.2,241.7c-.3.2-.5.5-.7.7.3-.2.5-.4.7-.7",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1426",
    d: "M561.8,256.6c.1-.4.1-.7.2-1.1-.1.3-.2.7-.2,1.1",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1427",
    d: "M601.9,269.9c.5-.5.9-1,1.3-1.5-.4.4-.9.9-1.3,1.5v0Z",
    fill: "#f49389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-s-path2",
    d: "M991.4,361.8h-970.4c-6-3.8-8.3-18.9-5.1-22.9c7.3-9.2,25.2-14.6,28.3-26.7-.2,7.7-3.6,15.1-4.5,22.5C49.2,321,66,323.6,80.4,318.1c20.7-7.9,37.3-22.4,49.5-40.5-4.9,18.1,11.9,35.4,10,54.8c2.9-5.7,8.5-11,13.7-14.3.1,7.3,3.7,14.3,4.1,22.1c10.7-5.3,17-18.3,26-26.1c8.9-7.7,18.3-11.8,26.1-21.1-6.7,12.5,3.4,12.7,12.2,18.3c7.8,5,22.3,17.5,21.4,28c4.8-12.4,3.4-24.3,13.8-34.3c11.3-10.8,27.8-12.4,38.2-25.3c8.7-10.8,6.3-25,12.5-36.8c5.2-9.9,18.2-13.7,24.6-23.5-3,8.1,4,13.2,6.9,20.4c3.5,8.8,1,15.4,1.7,23.5c6.3-9.1,2.1-19.3,5.4-28.9c3.2-9.2,13.5-16.5,21.3-21.7c10.4-6.8,20-12.8,28.4-22.1c8.2-9,8-16.2,10-27.4c3.1,16.2,10.3,34.7,6.7,51.9-1.9,9.1-7.4,17.4-8.3,26.8-1.2,12.8,5.2,21.7,7.3,33.1c2.2-8.7,7.4-13.5,13.8-16.8c2.1-1.1,4.3-2.1,6.6-3c9.1-3.5,19.1-6.1,26.2-13-10.9,11.8,15.3,23.5,21.5,31.1c2.1,2.7,4.3,5.6,6.1,8.7c2.7,4.5,4.8,9.4,5.4,14.4.6,5.5-.8,10.6-1.4,16.1-.2,1.9-.3,3.9-.2,5.9.8-1,1.5-2.1,2.3-3.2c3.8-5.5,7.3-11.5,12.3-15.7c6.6-5.5,14.2-5.3,21.2-10.2c5.6-3.9,10-8.8,15.2-13.1c2.2-1.9,4.6-3.6,7.3-5.1c6.6-3.6,12.1-7,13.6-14.7-1.5,10.2,4.7,13.6,11.7,21c3.1,3.2,4.9,6,5.8,8.6c1.7,4.6.5,9.1-1.7,15.7c3.9-5.4,5.5-11.9,9.1-17.6c2.3-3.7,5.8-6.4,9.2-9.1c2.2-1.7,4.3-3.4,6.1-5.4-3.5,5.2-.6,13.8-.9,19.9-.4,8-1.6,15.8.2,24.5c1,4.8,2.3,9.3,3.4,13.8c4.4-3.7,8.3-7.8,11.9-12.2c6-7.6,7.2-15.8,12.2-23.5c0,3.2-.1,6.4.1,9.6c5.7-2.4,8-18.5,11.6-24.5c5-8.4,13.4-14.6,17.3-23.5-.3,8.7,5.2,15.4,7.7,23.5c2.6,8.3,2.7,16.2,4.2,24.5c12.5-15.5,25.4-23.8,44.4-30.1c25-8.3,63.8-16.9,67.5-48.2.9,2.7,2.7,9.1,4,13.1c8.2-13.6,15.1-17.8,30.5-23.9c12.4-4.9,34.1-12.5,42.6-25.2-.2,4.2,2.4,9,4,12.4c3.9,8,4.8,14.2,4.8,23.2c0,10.4-1.6,20.7-4.8,30.5-2.8,8.7-6.4,17-10.8,24.9-3.5,6.3-10,13.9-11.2,20.8c9.4-8.9,13-22.6,25.8-27.5c7.5-2.9,16.4-1.6,21.5-9.5-1.3,4.1-2.2,8.4-2.8,12.7c6.3-2.9,11.9-7,17.4-11.3.8,10.7,9.5,19.5,9.4,31.4-.2,12.5-9.7,23.3-10,35c9-12.5,15.2-16.2,29.9-19.8c16.2-4,27.4-10.6,39.8-21.2-5.1,5.6,1,11.2,1.7,17.5.7,6.1-2.1,10.3-2.2,16c12.8,1.9,36.8-20.6,36.8-20.6c20.2,40.5-8.4,56.3-16.6,59.9Z",
    fill: "#f49389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1429",
    d: "M858.5,187.6c1.1-1.6,1.9-3.4,2.6-5.2-1.6,1.3-2.6,3.2-2.6,5.2v0Z",
    fill: "#f49389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1430",
    d: "M542.8,303.2c.3-.1.6-.3.8-.4-.3.1-.5.2-.8.4",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1431",
    d: "M322.8,280.6c.2-.4.4-.9.6-1.3-.2.4-.4.9-.6,1.3",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1432",
    d: "M822.4,248.9c.8-.2,1.6-.4,2.5-.6-.9.1-1.7.3-2.5.6v0Z",
    fill: "#f7b2ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1433",
    d: "M724,293.6c1.2,0,2.3,0,3.5,0-1.2-.2-2.4-.2-3.5,0v0Z",
    fill: "#f7b2ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hand-hell-s-rect1",
    width: 0,
    height: 0,
    rx: 0,
    ry: 0,
    transform: "translate(584.5 362.6)",
    fill: "#f7b2ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-s-path3",
    d: "M994.6,324.4c.2,7.2-8.4,30.2-17.9,37.4h-934.7c-5.3-4.3-3.9-13,2.7-16-.6,1.8-.1,4.1-.5,6c8.3-7.5,13-12.2,25.2-14.5c12.7-2.4,18.7-8.4,29-14.8-1.6,3.5-4.5,10.4-5.1,15.3c3.3-1.4,5.6-3.8,8.4-6.3.2,5.2-2.4,9.8-1.5,15c1.8-1.2,8.5-8.6,11.5-6.7s-1.2,10.3-1.6,12.7c4.6-8.7,24.7-9.6,32.9-16.1-1.9,2.6-2.7,10.9-2.8,14.7c9.1-3.5,20.9-2.4,29.8-7c11.3-5.8,18.8-18.4,31.9-20.6-5.1,7.7-8.2,18.5-3.4,26.8c2-3.2,4.8-5.8,8.1-7.5-4.1,12.3,15,8.7,22.4,7.6c3.9-.6,9.8-.5,13.8-1.5c6.2-1.5,6-3.3,8.6-9.2c7.3-16.8,18.4-22.3,34.7-30.9c16-8.4,29.1-12.1,36.7-28.1-2.4,6-.6,14.4-1.6,20.6-1.5,9.8-3,16.5,5,23.7-.6-20.7,18-28.2,28.5-42.2c11-14.5,8.4-37.9,22.7-49-8.1,10.1-2.6,32.2.9,42.9c3,9.2,6.1,20.1,4.8,29.9-1.1,8.1-3,15-3.1,23.6c6.5-9.5,12-15.8,23.9-17.6c9.1-1.3,12.8-1.5,20.6-5.9-.7,2-.6,4.1-1.3,5.9c10.7-4.2,18.6-14.8,20.8-26.3.6-3.1.8-6.3.5-9.4c4.3,8.2,7.4,15.6,8.3,24.4.2,2.4.3,4.9.2,7.5c0,.2,0,.4,0,.5-.5,9.3-2.3,18.1,1.3,25.5c1.5,3.1,3.9,5.9,7.8,8.4c2.6-6.8,3.8-11,1.8-17.9c1.7,5.1,11.6,11.4,15.2,17c6-9.8,14.4-11,23.1-14.2c2.6-1,5.2-2.1,7.8-3.7c10.8-6.7,21.3-15.5,32.8-21.3-3.5,2.5-2.4,12.8-3.7,17.4-2.1,7.9-10.8,15.3-11.6,22.8c10.1-1.9,16.5-6.2,25.6-11.4c7.9-4.5,14-10.8,20.2-17c2.4-2.4,3.8-4.7,7-5.2-4.9,8.6-5.4,30.3,5.2,35.5v0c.3.2.7.3,1,.4c7.5,2.8,20.6-1,26.3-6.3c6.5-6.2,7.5-17.4,16.5-21.2-1,3.7-1.8,8.4,3,9c6.2-7,7.9-17.4,14.8-23.4c1.6,4.9,4.9,10,6,15.1c1,4.5-1.6,9.6,3,12.2c4.1-7.5,12-8.3,19.2-12.3c8.8-4.9,12.9-14.6,21.6-19.2c8.6-4.6,17.6-5.7,27-5.9-3.5.9-3.3,4.5,1.4,6.1c8.7,2.9,13.5-2.2,18.6-7.5c13.3-13.6,31.9-21.3,48.6-30c9.9-5.1,19.3-10.6,29.8-13.4-8,2.9-5.8,12.9-6.5,20.1-1.5,15-8,26.7-17,39-5.6,7.6-8.1,14.8-7.3,20.8c4.1-4.2,8.9-7.6,14.3-9.9c17.8-7.8,40.1-7.3,55.7-19.1-6.6,5.5-4.9,17.5-6.5,25.4-.5,2.8-2.6,7.8-4.2,12.7c4.9-1.8,9.4-4.4,13.5-7.6c5-4,8-9.9,12.7-14.2c3.6-3.3,8.1-5.2,10.8-9.3.2,9.5-10.1,25.6-2.2,34.1.3.3.6.6.9.8c3.2-.5,6.5-.9,9.8-1.4c18.1-2.9,32.9-19.9,51.9-19.2-6.2,5.6-6.8,13.1-10.2,20c6.9-.2,13.3-3.2,19.7-3.2c10,0,5.5,4.2,3.2,9.1c7.4-.8,15.5-6.1,20.6-11.4c4.1-3.8,7.3-10,13.1-11.1Z",
    fill: "#f7b2ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1435",
    d: "M501,113.8c-.8,1.9-1.3,4-1.5,6.1.9-2,1.4-4,1.5-6.1v0Z",
    fill: "#f49389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1436",
    d: "M499.4,133c.4-4.7-.3-8.8.1-13.1-4.9,11.3-19.9,15.9-27.3,23.2-6.1,6.1-8.9,22.2-7.2,34.9l1.6,13.8c2.8-17,13.6-26.5,23.6-38c5.2-6,8.5-12.4,9.2-20.8v0Z",
    fill: "#f49389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1437",
    d: "M294.7,134.3c-6.3,6.4-7.4,9.7-10.2,14.6-3.8,6.5-3.2,11.9-3.6,19.2-.6,11.4-.9,27.7-8.2,36.8c12.6-13,24.1-16.8,25-36.8.8-16.4.8-33,12.3-46l-15.3,12.2Z",
    fill: "#f49389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1438",
    d: "M753,169.3c-5.1,10.1-15.3,24.4-25.3,32.1-8.5,6.5-17.5,16.8-16.1,28.6l.8,9.2c-.3.5-1.3.7-.6,1.1c6.6-11,17.1-18.6,26.5-27.1c5.8-5.3,9.9-11.3,11-19.2.6-5.3,2.3-19.9,3.7-24.7v0Z",
    fill: "#f49389"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-hand_to",
    transform: "translate(727.92,1198.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-hand_tr",
    transform: "rotate(7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-hand",
    transform: "translate(-150.999992,-328.166)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "hand-hell-s-polygon1",
    points: "287.1,42.2 286.4,49.7 284.2,75.2 267,128.7 241.5,187.2 234.8,224 235.2,239.5 236.1,276.6 235.8,280.9 235.8,280.9 234.7,295.1 232.8,320.1 229.3,332.3 229,333.5 221,361.4 218.6,403.6 217.6,420 87.4,420 87.3,393.3 87.3,371.1 86,367.7 82.6,358.8 77.1,344.6 76.5,343.1 58.8,316.7 55.6,311.9 54.7,306.2 54.7,306.2 53.1,297 53.1,297 48,266.6 53.9,248.2 59.8,229.4 54.3,188.5 50.6,178.5 24.7,109.1 19.2,90.2 19.2,90.2 4.2,38.4 0,10.4 13,0 24.2,0 29.2,6.9 29.2,6.9 29.2,6.9 40.5,22.6 60.2,81.2 60.2,81.2 65.2,96.1 87.3,140.4 97.4,155.9 98.6,145.4 100.7,127.4 116.2,107 137.1,107 143.5,113.2 150,119.5 154.6,137.5 165.9,114.9 183,107.4 199.3,117 202.1,123.5 202.1,123.5 202.1,123.5 203.7,127.1 205.6,131.6 205.6,131.6 206,132.5 206,156.3 206,156.3 206,156.3 225.1,125.4 225.1,125.4 229,119.1 229,119 257,48.5 270,38.4",
    fill: "#f2d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1399",
    d: "M216.7,220.8l-14.4,9.5l20.2,55.1L176.6,270L148,298.5l-14.4-19.3-44,19.3l19.7-25.4l6.6-18.8l11.6-16.6L142,225.5l5.9,5.3l13.4-2.5l11.3-12.8l10.3-29.8l9.1-16l14-13.4l19.1-30.9.5.7-21.5,61.5l12.6,33.2Z",
    fill: "#e1b4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1400",
    d: "M127.4,173L93.1,209.3L61,252.8L53.1,297l-5-30.4l5.8-18.4L66,232.7L96.1,191l31.3-18Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1401",
    d: "M143.5,113.2l-16.1-2.1L109,124.9v38.9L99,189.3l1.6-25.9v-35.9L116.1,107h20.9l6.5,6.2Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1402",
    d: "M202.1,123.5L183,114.1l-15.5,9.6-19.6,40.1l6.7-26.3l11.3-22.6l17.1-7.5l16.3,9.6l2.8,6.5Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1403",
    d: "M257,48.5l-28,70.6l22.6-37.6l13.8-29.3l12.1-6.3l9,3.8.7-7.5-17.1-3.8L257,48.5Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1404",
    d: "M13,0L0,10.4l4.2,28l15,51.7-10-55.9l4.6-21.3L29.2,6.8L24.5,0L13,0Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "hand-hell-s-rect2",
    width: 0,
    height: 0,
    rx: 0,
    ry: 0,
    transform: "translate(217.5 420.9)",
    fill: "#e1b4b3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "hand-hell-s-polygon2",
    points: "229.3,332.3 229,333.5 221,361.4 218.6,403.6 217.6,420 179,420 143.5,397 135.3,386.4 125.3,373.7 123.2,371 121.3,368.6 85.9,359.7 82.6,358.8 77.1,344.6 76.5,343.1 58.8,316.7 55.6,311.9 54.7,306.2 54.7,306.2 65.4,313.7 87.8,329.3 119.2,340.5 133.3,345.6 159.2,335.1 168,303.8 174,334.7 175,340.1 196,356.4 212.4,344.5",
    fill: "#e1b4b3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-groupe_352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand-hell-u-groupe_356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1406",
    d: "M181,253.3l-23.4,1.2-4.4,19.6-22.6-19.6L109.3,273l6.6-18.8l11.6-16.6L142,225.4l5.9,5.3l13.4-2.5l11.3-12.8l10.3-29.8l9.1-16l14-13.4-9.3,16.7-5,35.2l11.9,9.1-23,6.2c0,0,23,43,25.4,45.8s-25-15.9-25-15.9v0Z",
    fill: "#d29b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1407",
    d: "M100.7,156.3l-1.6,33-3,1.7L66,232.7l7.1-43.5-6.7-25.5v-38.4L60.1,81.1l5,14.9l22.1,44.3l10,15.5l1.2-10.4l2.3,10.9Z",
    fill: "#f2d1cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1408",
    d: "M205.6,131.6l-8.4,20.9-19.6,22.6-9.4-2.1l4.4,9.2-3.3,14.2-14.6,18.8L142,225.4l5.9,5.3l13.4-2.5l11.3-12.8l10.3-29.8l9.1-16l14-13.4v-23.8l-.4-.8Z",
    fill: "#e1b4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1409",
    d: "M133.3,181.2l14.6,18.3l7.7,1.7l12.1-7.7l1-13.4-9.4-11.3-8.4-1.7-11.3,5.9-6.3,8.2Z",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1410",
    d: "M150,119.5l-3.3,20.7-8.1,20.1L127.5,173l20.5-9.2l6.7-26.3-4.7-18Z",
    fill: "#e1b4b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hand-hell-u-trac-_1411",
    d: "M99.1,189.3l1.6-25.9-4.8,16.5L79,159.8l7.7,25.9-8.8,15.5l2.5,2.5-7.8,19.9L96.1,191l3-1.7Z",
    fill: "#e1b4b3"
  })))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "hand-hell-s-rect3",
    width: 0,
    height: 0,
    rx: 0,
    ry: 0,
    transform: "translate(584.5 420.9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHell);
export default __webpack_public_path__ + "static/media/hand-hell.15b80221c7d84e5400a0113f70a09330.svg";
export { ForwardRef as ReactComponent };